<template>
  <div class="fullWidth wrap fRow aStart jAround">
    <!-- card header -->
    <div class='fRow fullWidth jStart aStart'>
      <div class='growFull fCol jStart aStart'>
        <h3 class='growFull text-right'>{{ct}}</h3>
        <p class='note'>{{cd}}</p>
      </div>
    </div>
    <div class='sepLine' v-if='!this.isDelete'></div>
    <progress-bar w='100%' h='324px' msg='لطفا کمی صبر کنید' v-if="this.plsWait && !loadError"/>
    <error-bar w='100%' h='324px' :msg='msgError' v-if="!this.plsWait && loadError"/>
    <div class="fullWidth wrap fRow aStart jAround"
    v-if="!this.plsWait && !this.isDelete && !loadError">
      <div class="inputWrapper fCol aStart jStart ptitle">
        <span>عنوان</span>
        <input v-bind:class="{err: titleError}"
        placeholder="عنوان مجوز" type="text" v-model="peTitle"/>
      </div>
      <div class="inputWrapper fCol aStart jStart pPath">
        <span>localPath</span>
        <input placeholder="آدرس محلی" type="text" v-model="peLocalPath"/>
      </div>
      <div class="inputWrapper fCol aStart jStart pPath">
        <span>serverPath</span>
        <input placeholder="آدرس سرور" type="text" v-model="peServerPath"/>
      </div>
      <div class="inputWrapper fCol aStart jStart pParentId">
        <span>انتخاب سرشاخه</span>
        <div class="dropDownBtn" @click="getParents">
          <div class='inputValue'>{{peParentName}}</div>
        </div>
        <input id="parent" class="hide" placeholder="آیدی سر شاخته را انتخاب کنید" type="text"
        v-model="peParentId" @focus="getParents" @blur="closeParent" @keyup="notAllow('parent')"/>
        <div class="dropDown" v-if="parentDropDown">
            <div @click="selectParent('', 'بدون سرشاخه')" @blur="closeParent"
              class="item fullWidth">بدون سر شاخه</div>
            <div v-bind:key="item.id" v-for="item in pArray.data"
              @click="selectParent(item.id, item.title)" @blur="closeParent"
              class="item fullWidth">{{item.title}}</div>
        </div>
      </div>
      <div class="inputWrapper fCol aStart jStart pIcon">
        <span>انتخاب آیکن</span>
        <div class="dropDownBtn" @click="getIcon">
          <i class="material-icons-round" v-if="peIcon !== ''">{{peIcon}}</i>
          <div class="noIcon" v-if="peIcon === ''">بدون آیکُن</div>
        </div>
        <input id="icon" placeholder="انتخاب کنید" type="text" v-bind:class="{err: iconError}"
        class="hide" v-model="peIcon" @focus="getIcon" @blur="closeIcon" @keyup="notAllow('icon')"/>
        <div class="dropDown wrap fRow jStart aStart" v-if="iconDropDown">
            <input type="text">
            <i v-bind:key="items" v-for="items in mi" @click="selectIcon(items)"
            class="item material-icons-round icon">{{items}}</i>
        </div>
      </div>
      <div class="inputWrapper fCol aStart jStart pMethod" v-if="False">
        <span>متــُــد</span>
        <div class="dropDownBtn" @click="getMethod">
          <div class='inputValue'>{{peMethodName}}</div>
        </div>
        <input id="method" class="hide" placeholder="متد را انتخاب کنید" type="text"
        v-model="peMethod" @blur="closeMethod" @keyup="notAllow('method')"/>
        <div class="dropDown" v-if="methodDropDown">
          <div @click="selectMethod('')" class="item fullWidth">بدون متــُـد</div>
          <div @click="selectMethod('POST')" class="item fullWidth">POST</div>
          <div @click="selectMethod('GET')" class="item fullWidth">GET</div>
          <div @click="selectMethod('PUT')" class="item fullWidth">PUT</div>
          <div @click="selectMethod('DELETE')" class="item fullWidth">DELETE</div>
        </div>
      </div>
      <div class="fRow aStart jBetween wrap pMethod">
        <div @click="selectMethod('')"
          v-bind:class="{
            primary: peMethod === ''
          }"
          class="methodItem w50">بدون متــُـد</div>
        <div @click="selectMethod('POST')"
          v-bind:class="{
            POST: peMethod === 'POST'
          }"
          class="methodItem w50">POST</div>
        <div @click="selectMethod('GET')"
          v-bind:class="{
            GET: peMethod === 'GET'
          }"
          class="methodItem w50">GET</div>
        <div @click="selectMethod('PUT')"
          v-bind:class="{
            PUT: peMethod === 'PUT'
          }"
          class="methodItem w50">PUT</div>
        <div @click="selectMethod('PATCH')"
          v-bind:class="{
            PATCH: peMethod === 'PATCH'
          }"
          class="methodItem w50">PATCH</div>
        <div @click="selectMethod('DELETE')"
          v-bind:class="{
            DELETE: peMethod === 'DELETE'
          }"
          class="methodItem w50">DELETE</div>
      </div>
      <div class="inputWrapper fCol aStart jStart pState">
        <!-- <span>وضعیت</span> -->
        <div class="fullWidth fRow aCenter jCenter switchHolder" @click="changeState">
          <label class="growFull rtlText switchLabel">وضعیت نمایش</label>
          <switch-button :val='this.stateSwitch' activeLabel='فعال' deactiveLabel='غیرفعال'/>
        </div>
      </div>
      <div class="inputWrapper fCol aStart jStart pState">
        <!-- <span>وضعیت</span> -->
        <div class="fullWidth fRow aCenter jCenter switchHolder" @click="changeChildState">
          <label class="growFull rtlText switchLabel">زیرمجموعه</label>
          <switch-button :val='this.childSwitch' activeLabel='دارد' deactiveLabel='ندارد'/>
        </div>
      </div>
      <btn :label="this.cbl" btnWidth='70%' class="flexGrow"
      :icon="this.cbi" @click.native="mainFunction"/>
    </div>
    <div class="fullWidth wrap aStart jStart fRow btnRow"
    v-if="!this.plsWait && this.isDelete && !this.loadError">
      <btn label="بله، حذف شود" btnWidth='auto' bc='#ff0533'
      icon="delete_sweep" @click.native="deletePermission"/>
      <btn label="نه" btnWidth='auto' bc='#aaaaaa' icon="close" @click.native="closeModal"/>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Btn from '@/components/Btn.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import ErrorBar from '@/components/ErrorBar.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      peTitle: '',
      peParentId: '',
      peParentName: 'بدون سرشاخه',
      peLocalPath: '',
      peServerPath: '',
      peIcon: '',
      peMethod: '',
      peMethodName: 'بدون متــُــد',
      peHasChild: false,
      peState: 0,
      loadError: false,
      msgError: false,
      showChild: this.childSwitch,
      mi: ['dashboard', 'tune', 'assignment',
        'paid', 'business', 'category',
        'clear_all', 'menu_book', 'school', 'class',
        'ondemand_video', 'check_box', 'emoji_events'],
      parentDropDown: false,
      iconDropDown: false,
      stateDropDown: false,
      methodDropDown: false,
      isDataLoad: false,
      pArray: [],
      stateSwitch: true,
      childSwitch: false,
      titleError: false,
      iconError: false,
      ct: '',
      cd: '',
      cbl: '',
      cbi: '',
      addMode: false,
      editMode: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      modalStates: this.$store.state.modalState,
      plsWait: true,
      isDelete: false,
    };
  },
  props: ['mode'],
  computed: {},
  methods: {
    makeToast(toastType, toastMsg, d) {
      this.$store.commit('makeToast', { type: toastType, msg: toastMsg, duration: d });
    },
    getParents() {
      this.isDataLoad = false;
      this.parentDropDown = false;
      axios({
        method: 'get',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Permissions`,
      }).then((response) => {
        this.loadError = false;
        this.parentDropDown = true;
        this.posts = response.data;
        if (response.data.isSuccess) {
          this.isDataLoad = true;
          this.pArray = JSON.parse(JSON.stringify(this.posts));
        }
        document.getElementById('parent').focus();
      }, (error) => {
        // console.log(error);
        this.msgError = this.errorHandler(error);
        this.loadError = true;
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    selectParent(value, label) {
      this.peParentId = value;
      this.peParentName = label;
      // console.log(this.peParentName, this.peParentId);
      setTimeout(() => {
        this.parentDropDown = false;
      }, 200);
    },
    closeParent() {
      setTimeout(() => {
        this.parentDropDown = false;
      }, 160);
    },
    getIcon() {
      document.getElementById('icon').focus();
      this.iconDropDown = true;
    },
    closeIcon() {
      setTimeout(() => {
        this.iconDropDown = false;
      }, 160);
    },
    selectIcon(value) {
      this.peIcon = value;
      setTimeout(() => {
        this.iconDropDown = false;
      }, 90);
    },
    getState() {
      this.stateDropDown = true;
    },
    closeState() {
      setTimeout(() => {
        this.stateDropDown = false;
      }, 160);
    },
    selectState(value) {
      this.peState = value;
      setTimeout(() => {
        this.stateDropDown = false;
      }, 90);
    },
    getMethod() {
      document.getElementById('method').focus();
      this.methodDropDown = true;
    },
    closeMethod() {
      setTimeout(() => {
        this.methodDropDown = false;
      }, 160);
    },
    selectMethod(value) {
      this.peMethod = value;
      this.peMethodName = value;
      if (value === '') {
        this.peMethodName = 'بدون متـُـد';
      }
      setTimeout(() => {
        this.methodDropDown = false;
      }, 90);
    },
    permissionDataValidate() {
      if (this.peTitle === '') {
        this.titleError = true;
        return false;
      }
      this.titleError = false;
      if (this.peIcon === '') {
        this.iconError = true;
        return false;
      }
      this.iconError = false;
      if (this.peParentId === '') {
        this.peParentId = null;
      }
      if (this.stateSwitch) {
        this.perState = 1;
      } else {
        this.perState = 2;
      }
      // console.log('this.perState', this.perState);
      // console.log('this.childSwitch', this.childSwitch);
      return true;
    },
    returnState() {
      let x = 1;
      if (!this.stateSwitch) {
        x = 2;
      }
      return x;
    },
    returnHasChild() {
      return this.childSwitch;
    },
    postNewPermission() {
      if (this.permissionDataValidate()) {
        // console.clear();
        // console.log(this.peState);
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Permissions/`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            ParentId: this.peParentId,
            Title: this.peTitle,
            Icon: this.peIcon,
            LocalPath: this.peLocalPath,
            ServerPath: this.peServerPath,
            Method: this.peMethod,
            HasChild: this.childSwitch,
            State: this.perState === 1,
          },
        }).then((response) => {
          // console.log('JAVAB', response);
          if (response.data.isSuccess) {
            this.$store.commit('closeCard');
            this.changeMsg();
            this.makeToast('success', 'مجوز مورد نظر با موفقیت اضافه شد', 2000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 2000);
          // console.log(error);
        });
      }
    },
    editPermission() {
      // consolee.log('start edit permission');
      this.permissionDataValidate();
      // console.log('child switch', this.childSwitch);
      axios({
        method: 'put',
        url: `${this.baseURL}/api/v${this.V}/Permissions/${this.$store.state.focusPermissionId}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          parentId: this.peParentId,
          title: this.peTitle,
          icon: this.peIcon,
          localPath: this.peLocalPath,
          serverPath: this.peServerPath,
          method: this.peMethod,
          hasChild: this.returnHasChild(),
          state: this.returnState(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          // console.log('after edit permission', response.data);
          this.showChild = !this.showChild;
          this.$store.commit('closeCard');
          this.changeMsg();
          this.makeToast('success', 'مجوز مورد نظر با موفقیت ویرایش شد', 2000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 2000);
        // console.log(error);
      });
    },
    changeMsg() {
      this.$emit('changeMsg', 'hey');
      // console.log('message emit from child component');
    },
    mainFunction() {
      switch (this.mode) {
        case 'add': {
          this.postNewPermission();
          break;
        }
        case 'edit': {
          this.editPermission();
          break;
        }
        default:
          break;
      }
    },
    deletePermission() {
      axios({
        method: 'delete',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Permissions/${this.$store.state.focusPermissionId}`,
      }).then((response) => {
        // console.log('delete', response);
        if (response.data.isSuccess) {
          this.$store.commit('closeCard');
          this.changeMsg();
          this.makeToast('success', 'مجوز مورد نظر با موفقیت حذف شد', 2000);
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    closeModal() {
      this.$store.commit('closeCard');
    },
    changeState() {
      this.stateSwitch = !this.stateSwitch;
      // consolee.log(this.stateSwitch);
    },
    changeChildState() {
      this.childSwitch = !this.childSwitch;
      // console.log(this.childSwitch);
    },
    notAllow(inp) {
      // alert(inp);
      switch (inp) {
        case 'method': {
          this.peMethod = this.peMethod.slice(0, this.peMethod.length - 1);
          break;
        }
        case 'icon': {
          this.peIcon = this.peIcon.slice(0, this.peIcon.length - 1);
          break;
        }
        case 'parent': {
          this.peParentId = this.peParentId.slice(0, this.peParentId.length - 1);
          break;
        }
        default:
          break;
      }
    },
  },
  components: {
    Btn,
    SwitchButton,
    ProgressBar,
    ErrorBar,
  },
  mounted() {
    switch (this.mode) {
      case 'add': {
        this.isDelete = false;
        this.ct = 'اضافه کردن مجوز جدید';
        this.cd = 'فرم زیر را تکمیل کنید';
        this.cbl = 'اضافه کردن مجوز';
        this.cbi = 'add';
        this.addMode = true;
        this.editMode = false;
        this.plsWait = false;
        // console.clear();
        // console.log(this.stateSwitch, this.childSwitch);
        break;
      }
      case 'edit': {
        this.isDelete = false;
        this.ct = 'ویرایش کردن مجوز';
        this.cd = 'اطلاعات زیر را ویرایش و ذخیره کنید';
        this.cbl = 'ثبت تغییرات';
        this.cbi = 'save';
        this.addMode = false;
        this.editMode = true;
        axios({
          method: 'get',
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          url: `${this.baseURL}/api/v${this.V}/Permissions/${this.$store.state.focusPermissionId}`,
        }).then((response) => {
          // consolee.log('from permission manager in edit mode →', response.data.data.id);
          if (response.data.isSuccess) {
            this.peParentId = response.data.data.parentId;
            this.peTitle = response.data.data.title;
            this.peLocalPath = response.data.data.localPath;
            this.peServerPath = response.data.data.serverPath;
            this.peIcon = response.data.data.icon;
            this.peMethod = response.data.data.method;
            if (response.data.data.state === 1) {
              this.stateSwitch = true;
            } else {
              this.stateSwitch = false;
            }
            this.childSwitch = response.data.data.hasChild;
            // console.log(this.stateSwitch, this.childSwitch);
          }
          this.plsWait = false;
        }, (error) => {
          // console.log(error);
          this.makeToast('error', this.errorHandler(error), 2000);
        });
        break;
      }
      case 'delete': {
        this.plsWait = false;
        this.isDelete = true;
        this.ct = `آیا از حذف مجوز "${this.$store.state.focusPermissionName}" مطمئن هستید؟`;
        this.cd = 'این عملیات قابل بازیابی نیست.';
        break;
      }
      default:
        break;
    }
  },
};
</script>

<style lang='scss' scoped>
.inputWrapper{
    margin-bottom: 24px;
    position: relative;
}
.inputWrapper span{
    font-size: 10px;
    padding-right: 8px;
    margin-bottom: 8px;
}

.inputWrapper input, .dropDownBtn{
    border: solid 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 4px;
    width: 100%;
    padding: 0px 12px;
    position: relative;
    height: 40px;
    transition: all ease-in-out 0.3s;
}

.dropDownBtn{
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.inputValue{
  font-size: 14px;
  text-align: right;
  pointer-events: none;
}

.inputWrapper .hide{
  opacity: 0;
  transform: scale(0);
}

.inputWrapper input:focus{
    border: solid 2px rgba($color: #000000, $alpha: 0.4);
    outline: none;
    border-radius: 8px;
    width: 100%;
    padding: 8px 12px;
}

.inputWrapper .dropDown{
    position: absolute;
    top: calc(24px - 0px);
    left: -8px;
    right: -8px;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 264px;
    background-color: var(--normalText1);
    box-shadow: 0 8px 32px 0 rgba($color: #000000, $alpha: 0.25);
    border-radius: 8px;
    z-index: 300;
}

.inputWrapper .err {
  border-color: red;
  color: red;
}

.inputWrapper .dropDown .item{
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 200;
    color: black;
    text-align: right;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
}

.item.icon{
    width:  25% !important;
    height: 40px !important;
    display: flex;
    border-radius: 80px;
    justify-content: center;
    align-items: center;
    font-size: 24px !important;
}

.inputWrapper .dropDown .item:hover{
    background-color: rgba($color: #000000, $alpha: 0.05);
    color: #61187A;
}

.ptitle, .pParentId{
    width: calc(50% - 8px);
}

.pPath{
    width: calc(25% - 8px);
    input[type="text"] {
      text-align: left;
      direction: ltr !important;
    }
}
.pIcon{
    width: calc(25% - 8px);
}
.pState{
    width: calc(25% - 8px);
}
.pMethod{
  width: calc(25% - 8px);
  .methodItem {
    padding: 6px 10px;
    border-radius: 24px;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    margin-bottom: 8px;
    color: white;
    background-color: rgba($color: #000000, $alpha: 0.25);
    transition: all ease-in-out 0.1s;
  }
}
.pHasChild{
    width: calc(60% - 8px);
}

.switchHolder{
  cursor: pointer;
}

.switchLabel{
  font-size: 12px;
  font-weight: 300;
  pointer-events: none;
}

.btnRow{
  margin-top: 16px;
}

.noIcon {
  font-size: 14px;
  pointer-events: none;
}
</style>
